import { render, staticRenderFns } from "./FormInputSupportType.vue?vue&type=template&id=66fecd2e&scoped=true&lang=pug"
import script from "./FormInputSupportType.vue?vue&type=script&lang=ts"
export * from "./FormInputSupportType.vue?vue&type=script&lang=ts"
import style0 from "./FormInputSupportType.vue?vue&type=style&index=0&id=66fecd2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fecd2e",
  null
  
)

export default component.exports